import React from "react";
export const Barcode = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.45297 8.54703V14H2V8.54703H7.45297ZM11.8205 12.9103V14H10.7265V12.9103H11.8205ZM13.9913 12.9103V14H12.9103V12.9103H13.9913ZM11.8205 8.56874V9.65847H12.9103V8.54703H14V11.8205H10.7265V10.7265H9.63676V14H8.54703V8.54703L11.8205 8.56874ZM6.36324 9.63676H3.08972V12.9016H6.36324V9.63676ZM5.27352 10.7265V11.8205H4.17945V10.7265H5.27352ZM7.44428 2V7.45297H2V2H7.44428ZM13.9913 2V7.45297H8.54703V2H13.9913ZM6.36324 3.08972H3.08972V6.36324H6.36324V3.08972ZM12.9103 3.08972H9.63676V6.36324H12.9103V3.08972ZM5.27352 4.17945V5.27352H4.17945V4.17945H5.27352ZM11.8205 4.17945V5.27352H10.7265V4.17945H11.8205Z"
        fill="url(#paint0_linear_1188_63948)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1188_63948"
          x1="2"
          y1="7.99999"
          x2="14"
          y2="7.99999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFCB57" />
          <stop offset="1" stopColor="#FF7443" />
        </linearGradient>
      </defs>
    </svg>
  );
};
